import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Vant from 'vant';
// import 'vant/lib/index.css';
import '../public/css/vant.css'

import VueClipboard from 'vue-clipboard2'

import global from './components/Common.vue';
import VueI18n from 'vue-i18n';
// import VueCookies from 'vue-cookies'

import LangEn from './i18n/lang/en.js';
import LangCn from './i18n/lang/cn.js';

Vue.prototype.common = global;

Vue.use(Vant);
Vue.use(VueI18n);
// Vue.use(VueCookies)
Vue.use(VueClipboard)

Vue.config.productionTip = false

const messages = {
    'en': LangEn,
    'cn': LangCn
};


// 自动获取获取系统语言
let language_str = navigator.language.toLowerCase() == 'zh-cn' ? 'cn' : 'en'; //true表示中文，false为英文
// let language_str = 'en'; // 默认为英文

// 默认显示英文
const i18n = new VueI18n({
    locale: language_str,
    messages
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
